document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-home-hero]');
  if (!root) return;

  const carousel = root.querySelector('[data-hero-carousel]');
  const track = root.querySelector('.home-hero__track');
  const slides = Array.from(root.querySelectorAll('.home-hero__slide'));
  const dots = Array.from(root.querySelectorAll('.home-hero__dot-btn'));

  if (!track || slides.length === 0) return;

  let index = 0;
  let startX = 0;
  let currentX = 0;
  let prevTranslate = 0;
  let isDragging = false;
  let animationId = null;
  let slideWidth = slides[0].offsetWidth;

  function setPosition(translate) {
    track.style.transform = `translateX(${translate}px)`;
  }

  function setActiveDot(i) {
    dots.forEach((dot, idx) => {
      dot.classList.toggle('is-active', idx === i);
    });
  }

  function snapToSlide(i) {
    index = Math.max(0, Math.min(i, slides.length - 1));
    prevTranslate = -index * slideWidth;
    setPosition(prevTranslate);
    setActiveDot(index);
  }

  function getX(e) {
    return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
  }

  function dragStart(e) {
    isDragging = true;
    startX = getX(e);
    track.classList.add('is-dragging');
    animationId = requestAnimationFrame(animation);
  }

  function dragMove(e) {
    if (!isDragging) return;
    const x = getX(e);
    currentX = x - startX;
  }

  function dragEnd() {
    cancelAnimationFrame(animationId);
    isDragging = false;
    track.classList.remove('is-dragging');

    const movedBy = currentX;
    if (movedBy < -50) index += 1;
    if (movedBy > 50) index -= 1;

    snapToSlide(index);
    currentX = 0;
  }

  function animation() {
    if (!isDragging) return;
    setPosition(prevTranslate + currentX);
    requestAnimationFrame(animation);
  }

  slides.forEach(slide => {
    slide.addEventListener('mousedown', dragStart);
    slide.addEventListener('touchstart', dragStart, { passive: true });

    slide.addEventListener('mousemove', dragMove);
    slide.addEventListener('touchmove', dragMove, { passive: true });

    slide.addEventListener('mouseup', dragEnd);
    slide.addEventListener('mouseleave', dragEnd);
    slide.addEventListener('touchend', dragEnd);
  });

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      snapToSlide(Number(dot.dataset.slide));
    });
  });

  window.addEventListener('resize', () => {
    slideWidth = slides[0].offsetWidth;
    snapToSlide(index);
  });

  snapToSlide(0);
});

document.addEventListener('DOMContentLoaded', () => {

  const hero = document.querySelector('.home-hero');
  const testimonial = document.querySelector('.testimonial-video');

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    },
    { threshold: 0.25 }
  );

  if (hero) observer.observe(hero);
  if (testimonial) observer.observe(testimonial);
  const thumbnailVideo = document.querySelector('.video-thumbnail');
  const videoMain = document.querySelector('.testimonial-video__media-wrapper video')
  if(thumbnailVideo){
    thumbnailVideo.addEventListener('click', function(){
      videoMain.play();
      thumbnailVideo.classList.add('played')
    })
  }
});
